// Copyright Caproc Oy
// System name: Aqua-Net
// System module: Company
// Author: TS
//
// 7.4.2026 TS (claude) Fixed eslint warnings: removed unused 'role_options', added array-callback-return null branches

import React from "react";
import { Message, Header, Button, Table, Segment, Dimmer, Loader, Image, Menu } from "semantic-ui-react";
import Shell from "./Shell";
import { authAxios } from "../../utils";
import { setActivity } from "../../store/actions/auth";
import { withRouter, Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import { companyUsersListURL, companyUserRoleOptionsURL } from "../../constants";


class CompanyUsers extends React.Component {
    state = {
        users: null,
        role_options: null,
        activeMenuItem: this.props.t("Active"),
        error: null,
        loading: false
    };

    componentDidMount() {
        this.props.setActivity();
        this.fetctRoleOptions();
        this.handleFetchUserList();
    }

    fetctRoleOptions = () => {
        this.setState({
            loading: true
        });
        const { activeCompanyId } = this.props;

        authAxios
            .get(companyUserRoleOptionsURL(activeCompanyId))
            .then(res => {
                this.setState({
                    role_options: res.data,
                    error: null,
                    loading: false,
                });
            })
            .catch(err => {
                this.setState({
                    loading: false,
                    error: err
                });
            });

    };

    handleFetchUserList = () => {
        this.setState({
            loading: true,
        });
        const { activeCompanyId } = this.props;
        authAxios
            .get(companyUsersListURL(activeCompanyId))
            .then(res => {
                this.setState({
                    users: res.data,
                    error: null,
                    loading: false
                });
            })
            .catch(err => {
                this.setState({
                    loading: false,
                    error: err
                });
            });
    };

    userDetails = (id) => {
        this.props.history.push(`/company/user-details/${id}/`)
    };

    handleMenuItemClick = (e, { name }) => this.setState({ activeMenuItem: name });

    render() {
        const { error, loading, users, activeMenuItem } = this.state;
        const { isAuthenticated, activeCompanyId, t } = this.props;
        if (!isAuthenticated) {
            return <Redirect to="/login" />;
        }
        // console.log(this.state);
        return (
            <Shell>
                <Header as="h3">{t("Company users")}</Header>
                <Link to={`/company/user-details/create/`}>
                    <Button type="button" floated="right" color="green">
                        {t("+ User")}
                    </Button>
                </Link>

                {error && (
                    <Message
                        error
                        header={t("There was an error")}
                        content={JSON.stringify(error)}
                    />
                )}
                {loading && (
                    <Segment>
                        <Dimmer active inverted>
                            <Loader inverted>Loading</Loader>
                        </Dimmer>
                        <Image src="https://react.semantic-ui.com/images/wireframe/short-paragraph.png" />
                    </Segment>
                )}
                <Menu attached="top" tabular>
                    <Menu.Item
                        name={t("Active")}
                        active={activeMenuItem === t("Active")}
                        onClick={this.handleMenuItemClick} />
                    <Menu.Item
                        name={t("Archive")}
                        active={activeMenuItem === t("Archive")}
                        onClick={this.handleMenuItemClick} />
                </Menu>
                {users && (
                    <Table striped selectable celled>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>{t("First name")}</Table.HeaderCell>
                                <Table.HeaderCell>{t("Last name")}</Table.HeaderCell>
                                <Table.HeaderCell>{t("Title")}</Table.HeaderCell>
                                <Table.HeaderCell>{t("Email")}</Table.HeaderCell>
                                <Table.HeaderCell>{t("Phone")}</Table.HeaderCell>
                                <Table.HeaderCell>{t("Role")}</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {users.map((user) => {
                                if ((activeMenuItem === t("Active") && user.is_active) || (activeMenuItem === t("Archive") && !user.is_active)) {
                                    return (
                                        <Table.Row key={user.id} onClick={() => this.userDetails(user.id)}>
                                            <Table.Cell>{user.first_name}</Table.Cell>
                                            <Table.Cell>{user.last_name}</Table.Cell>
                                            <Table.Cell>{user.title}</Table.Cell>
                                            <Table.Cell>{user.email}</Table.Cell>
                                            <Table.Cell>{user.phone_number}</Table.Cell>
                                            <Table.Cell>
                                                {user.userroles.map(role => {
                                                    if (parseInt(role.company) === parseInt(activeCompanyId))
                                                        return (
                                                            <React.Fragment>
                                                                {t(role.role_name)} <br/>
                                                            </React.Fragment>
                                                        );
                                                    return null;
                                                })}
                                            </Table.Cell>
                                        </Table.Row>
                                    );
                                }
                                return null;
                            })}
                        </Table.Body>
                    </Table>
                )}
            </Shell>
        );
    }
}
const mapStateToProps = state => {
    return {
        activeCompanyId: state.company.activeCompanyId,
        isAuthenticated: state.auth.token !== null
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setActivity: () => dispatch(setActivity())
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(withTranslation('companyusers')(CompanyUsers))
);